/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Tooltip } from 'antd'
import { Message } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { EyeOutlined } from '@ant-design/icons'
import React, { useState, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import MessageItemModal from './MessageItemModal/MessageItemModal'
import {
  readUserMessageSelector,
  getMessagesSelector,
  resetReadMessage,
  readUserMessage,
} from 'src/features'

const MessageItemAction: React.FC<{ message: Message }> = ({ message }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const { messages: originalMessagesList } = useAppSelector(getMessagesSelector)
  const {
    loading: loadingRead,
    success: successRead,
    currentMessage
  } = useAppSelector(readUserMessageSelector)

  useEffect(() => {
    if (successRead && currentMessage === message.id) {
      dispatch(resetReadMessage())
    }
  }, [successRead, message])

  const handleShowClick = () => {
    setIsModalVisible(true)
    if (!message.read) { dispatch(readUserMessage(message.id, originalMessagesList)) }
  }

  return <>
    <Tooltip title={t('Messages.ShowComplete')} color='blue'>
      <Button
        type='ghost'
        shape='circle'
        loading={loadingRead && currentMessage === message.id}
        icon={<EyeOutlined />}
        onClick={handleShowClick}
      />
    </Tooltip>
    <MessageItemModal
      isModalVisible={isModalVisible}
      handleCancel={() => setIsModalVisible(false)}
      message={message}
    />
  </>
}

export default MessageItemAction
